module.exports = __webpack_public_path__ + "static/media/about-3.f7f3048e.jpg";